import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceShare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceShare"><Path d="M7.5 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 9.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 7.5V16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 5.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 17.5V13.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 20.5C16.5 17.6268 17.8013 15.7682 20 13.9106" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVoiceShare;
